import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
const STATS = [{
  value: '+3.500',
  label: 'Emprendedores usando nuestros recursos'
}, {
  value: '92%',
  label: 'Implementa su primer embudo en 7 días'
}, {
  value: '+120',
  label: 'Productos digitales desarrollados'
}, {
  value: '4.9/5',
  label: 'Valoración promedio de clientes'
}];
const PILLARS = [{
  icon: ZapIcon,
  title: 'Implementación, no teoría',
  description: 'Cada producto incluye plantillas, guiones y pasos concretos. Nada de contenido para archivar.'
}, {
  icon: TrendingUpIcon,
  title: 'Pensado para vender',
  description: 'Diseñamos con foco en conversión: mensajes, embudos y ofertas que generan ingresos.'
}, {
  icon: ShieldCheckIcon,
  title: 'Calidad de estudio',
  description: 'Estética consistente, sistemas de diseño reales y actualizaciones continuas.'
}];
const ease = [0.22, 1, 0.36, 1] as const;
export function WhyUs() {
  return <section id="nosotros" className="relative w-full overflow-hidden border-t border-white/[0.06] py-28 sm:py-32 lg:py-44" data-id="element-517" data-mp="3eccsk492xnwp">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-518" data-mp="3nbq73bc292oa">
        <div className="absolute left-1/2 top-1/3 h-[520px] w-[820px] -translate-x-1/2 rounded-full blur-[130px]" style={{
        background: 'radial-gradient(circle at 35% 40%, rgba(37,99,246,0.15), transparent 62%), radial-gradient(circle at 70% 60%, rgba(139,92,246,0.15), transparent 62%)'
      }} data-id="element-519" data-mp="3n9n4lrtq1h2o" />
      </div>

      <div className="relative mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-520" data-mp="aukvibg36drn">
        <div className="mx-auto max-w-3xl text-center" data-id="element-521" data-mp="eumzir9anja3">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-white/35" data-id="element-522" data-mp="2clfutd9i4v34">
            Por qué Creativo Digital
          </p>
          <h2 className="mt-7 text-3xl font-semibold leading-[1.15] tracking-[-0.025em] text-white sm:text-[2.9rem]" data-id="element-523" data-mp="2go2qjp9an05l">
            No vendemos información.
            <span className="mt-2 block gradient-text" data-id="element-524" data-mp="3eyu8m3t6v7h5">
              Creamos herramientas para hacer crecer negocios.
            </span>
          </h2>
        </div>

        <dl className="mt-16 grid grid-cols-2 gap-5 lg:mt-20 lg:grid-cols-4" data-id="element-525" data-mp="3szya4iwkvvpq">
          {STATS.map((stat, i) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.07,
          ease
        }} className="rounded-3xl border border-white/[0.07] bg-white/[0.02] p-8 backdrop-blur-sm sm:p-9" data-id="element-526" data-mp="3oz4j3gnua0sm" data-mpi={i}>
              <dt className="text-3xl font-semibold tracking-[-0.02em] text-white sm:text-[2.4rem]" data-id="element-527" data-mp="bk88gcf2g3id">
                {stat.value}
              </dt>
              <dd className="mt-4 text-[13px] font-light leading-relaxed text-white/45" data-id="element-528" data-mp="kjlcuqoc21w8">
                {stat.label}
              </dd>
            </motion.div>)}
        </dl>

        <ul className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-529" data-mp="19486fwn4l635">
          {PILLARS.map((pillar, i) => <motion.li key={pillar.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease
        }} className="rounded-3xl border border-white/[0.07] bg-[#131317]/60 p-9 backdrop-blur-sm transition-colors duration-300 hover:border-white/[0.16] sm:p-10" data-id="element-530" data-mp="v4p2lg1ckgwn" data-mpi={i}>
              <span className="grid h-11 w-11 place-items-center rounded-2xl bg-gradient-to-br from-[#2563f6]/25 to-[#8b5cf6]/25 ring-1 ring-inset ring-white/10" data-id="element-531" data-mp="be3jw4fzcs8h">
                <pillar.icon aria-hidden="true" className="h-5 w-5 text-[#b49cff]" strokeWidth={1.5} data-id="element-532" data-mp="2fruu6uri2i5" />
              </span>
              <h3 className="mt-7 text-[17px] font-medium tracking-tight text-white" data-id="element-533" data-mp="3vhq0ccw55z1h">
                {pillar.title}
              </h3>
              <p className="mt-4 text-[14px] font-light leading-relaxed text-white/45" data-id="element-534" data-mp="3qmanno9ve96n">
                {pillar.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}